import React, { lazy, memo, Suspense } from 'react';
import { Loader } from '@Sage/hoi-poi-ui';

import { RICH_TEXT_OVERRIDES, richTextPropTypes } from './contract';

const RichTextEditor = lazy(() => import('./RichTextEditor'));

const RichText = memo((props) => {
    return (
        <Suspense fallback={<Loader size="big" />}>
            <RichTextEditor {...props} />
        </Suspense>
    );
});

RichText.displayName = 'RichText';
RichText.overrides = RICH_TEXT_OVERRIDES;
RichText.propTypes = richTextPropTypes;

export { RichTextContext } from './contract';
export default RichText;
